import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=61b3f36e"
import script from "./Sensors.vue?vue&type=script&lang=js"
export * from "./Sensors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports